"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCheckCircle = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=check&icon=check_circle&style=baseline
const IconCheckCircle = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })));
};
exports.IconCheckCircle = IconCheckCircle;
